module.exports = __webpack_public_path__ + "images/interview-Ford_Motor_Company-2.svg";